// /planos depois de 14/10/2026: o app é grátis e não há plano do app para
// vender. Quem chega por um link antigo (e-mail, magic link do iOS) vê isto.
// Assinar um Mentor é pelo app, na loja do aparelho.
import React from 'react';

export const PlanosAposentados: React.FC<{ logado: boolean }> = ({ logado }) => (
  <div data-tela="planos-aposentados" style={{
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '32px 22px', background: 'var(--paper, #F5F1EA)', color: 'var(--ink, #1F1A14)',
  }}>
    <div style={{ maxWidth: 440, display: 'flex', flexDirection: 'column', gap: 14 }}>
      <h1 style={{ margin: 0, fontSize: 30, lineHeight: 1.15, fontWeight: 500 }}>
        O Forjamente é grátis
      </h1>
      <p style={{ margin: 0, fontSize: 16, lineHeight: 1.6, color: 'var(--ink-2, #4A4036)' }}>
        O app inteiro é seu, sem assinatura: registro, caderno, Protocolo, Modo Foco,
        relatórios e clubes. Assinar um Mentor é pelo app, no iPhone ou no Android.
      </p>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 8 }}>
        <a href="/" style={{
          padding: '12px 20px', borderRadius: 999, background: 'var(--ember, #C7531A)',
          color: 'var(--paper, #F5F1EA)', fontWeight: 600, textDecoration: 'none',
        }}>{logado ? 'Abrir o app' : 'Entrar'}</a>
        <a href="/baixar?de=planos" style={{
          padding: '12px 20px', borderRadius: 999, border: '1px solid var(--line-strong, #CFC6B8)',
          color: 'var(--ink, #1F1A14)', fontWeight: 500, textDecoration: 'none',
        }}>Baixar o app</a>
      </div>
    </div>
  </div>
);

export default PlanosAposentados;
